import tagsIndex from './tags/index';
import postsNew from './posts/new';
import postsEdit from './posts/edit';
import copyCheckResultsIndex from './copy-check-results/index';
import creatorsForm from './creators/form';
import recommendSitesIndex from './recommend_sites/index';
import adPostIndex from './ad_posts/index';

export const configureRoutes = () => {
  const routes = new Map();
  routes.set('tags-index', tagsIndex);
  routes.set('posts-new', postsNew);
  routes.set('posts-edit', postsEdit);
  routes.set('copy-check-results-index', copyCheckResultsIndex);
  routes.set('creators-form', creatorsForm);
  routes.set('recommend-sites-index', recommendSitesIndex);
  routes.set('ad-post-index', adPostIndex);

  return routes;
};
